import moment from 'jalali-moment';

export const getYears = (length: number) => {
  const today = new Date();
  const year = moment(today).locale('fa').format('YYYY');
  return createCountDown(Number(year), length);
};

export const getYearsUp = () => {
  const today = new Date();
  const year = moment(today).locale('fa').format('YYYY');
  return createCountUp(Number(year));
};

const createCountUp = (year: number): Array<IOption> => {
  const years: Array<IOption> = [];
  for (let index = year; index < year + 10; index++) {
    const option: IOption = {
      label: index.toString(),
      value: index,
    };
    years.push(option);
  }
  return years.reverse();
};

const createCountDown = (year: number, length: number): Array<IOption> => {
  const years: Array<IOption> = [];
  for (let index = year; index > year - length; index--) {
    const option: IOption = {
      label: index.toString(),
      value: index,
    };
    years.push(option);
  }
  return years;
};
